import { render, staticRenderFns } from "./CarouselOrItem.vue?vue&type=template&id=92ee7eb2"
import script from "./CarouselOrItem.vue?vue&type=script&lang=js"
export * from "./CarouselOrItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports